/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsProductLevelFeature
 */
export interface MelcoModelsProductLevelFeature {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsProductLevelFeature
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsProductLevelFeature
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsProductLevelFeature
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsProductLevelFeature
     */
    description?: string | null;
}

export function MelcoModelsProductLevelFeatureFromJSON(json: any): MelcoModelsProductLevelFeature {
    return MelcoModelsProductLevelFeatureFromJSONTyped(json, false);
}

export function MelcoModelsProductLevelFeatureFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsProductLevelFeature {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function MelcoModelsProductLevelFeatureToJSON(value?: MelcoModelsProductLevelFeature | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'code': value.code,
        'name': value.name,
        'description': value.description,
    };
}


